<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    @if (headshotUploadService.showTips) {
      <div class="vtz-title-section vtz-title-section--blue">
        <app-header></app-header>
      </div>
    }
    <main>
      <h1 class="vtz-h1" i18n>Facial Verification</h1>
      @if (headshotUploadService.showTips) {
        <div class="tips-container">
          <h2 class="vtz-text vtz-text--wide vtz-text--bold" i18n>Facial Verification Tips</h2>
          <ul class="feedback-tips" i18n>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Ensure your face is fully visible and well-lit.
            </li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Avoid wearing hats, sunglasses, or any accessories that cover your face.
            </li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Position yourself in front of a light source, such as a window or lamp.
            </li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Avoid strong backlight (e.g., light behind you).</li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Keep a neutral or natural expression.</li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Keep your camera steady and clean the lens if necessary.</li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Align your face within the frame and look directly at the camera.</li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Once aligned, press the start button to begin the process.
            </li>
            <li>
              <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
              Follow the instructions on the top of the camera.
            </li>
          </ul>
          <div class="button-group" style="margin-top: 15px;">
            <button class="button button-primary" (click)="goToDetection()" i18n="Button label">
              NEXT
            </button>
          </div>
        </div>
      } @else {
        @if (faceLandmarker) {
          <app-liveness [model]="faceLandmarker" (finalPicture)="processImage($event)"></app-liveness>
        }      
      }
    </main>
  </div>
</div>
<app-back-button-confirmation-modal></app-back-button-confirmation-modal>
@if (displaySpinner) {
  <div class="progressSpinner">
    <mat-spinner [diameter]="300" color="primary"></mat-spinner>
    <div class="spinner-warning">
      <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
    </div>
  </div>
}